
import { Component, Vue, Prop } from 'vue-property-decorator'
import { setProductInfo } from '@/api/product/product'
import { Form as ElForm } from 'element-ui'
import { AppModule } from '@/store/modules/app'
import { getProductInfo } from '@/api/product/productAccount'
import thaiQRExtra from './thaiQRExtra.vue'

@Component({
  name: 'trueh5Extra',
  components: {
    thaiQRExtra
  }
})
export default class extends Vue {
  @Prop({ required: true }) private product!: any

  private extraParam: any = {
    checkout_counter_expire_time: 0,
    amount_timeout: null
  }

  private rules: any = {
    checkout_counter_expire_time: [
      {
        required: true,
        message: '请输入时间',
        trigger: 'blur'
      }
    ]
  }

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  private back() {
    this.$emit('close', false)
  }

  private async extraUpdate() {
    (this.$refs.extraParam as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        const data: any = {
          id: this.product.id,
          extra_param: {
            checkout_counter_expire_time: Number(
              this.extraParam.checkout_counter_expire_time
            )
          }
        }
        await setProductInfo(data).then(() => {
          this.$message({
            message: 'Modified successfully!',
            type: 'success'
          })
          this.flagStr()
          this.back()
        })
      } else {
        return false
      }
    })
  }

  // 产品详情
  private async getInfo() {
    const data = {
      id: this.product.id
    }
    await getProductInfo(data).then((res: any) => {
      if (res) {
        this.extraParam = {
          checkout_counter_expire_time:
            res.extra_param.checkout_counter_expire_time
        }
      } else {
        this.extraParam = {
          checkout_counter_expire_time: 0
        }
      }
    })
  }

  mounted() {
    this.getInfo()
  }
}
